<template>
  <v-card class="fiterCard pa-5" flat>
    <p class="filterCaption">Filtros</p>
    <v-row>
      <v-col sm="3" v-for="filter in filters" :key="filter.name">
        <FilterSelect
          v-model="filterValues[filter.option]"
          :label="filter.name"
          :selectOptions="filter.options"
          :value="filterValues[filter.option]"
          :option="filter.option"
          :filterValues="filterValues"
        />
      </v-col>
    </v-row>
    <v-row style="margin-top: -20px;">
      <v-col sm="3" v-for="datePicker in datePickers" :key="datePicker.label">
        <FilterDatePicker
          v-model="filterValues[datePicker.option]"
          :label="datePicker.label"
          :value="filterValues[datePicker.option]"
        />
      </v-col>
      <v-spacer></v-spacer>
      <v-col sm="3" class="d-flex">
        <v-spacer></v-spacer>
        <v-btn @click="resetFilters" class="cancelButton" color="#FFFFFF">
          <span class="buttonText">Limpar</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import FilterSelect from "@/components/atoms/filter-select";
import FilterDatePicker from "@/components/atoms/filter-date-picker";

export default {
  components: {
    FilterSelect,
    FilterDatePicker
  },
  data() {
    return {
      filters: [
        {
          option: "country",
          name: "País:",
          options: this.$store.state.filterOptions.country
        },
        {
          option: "state",
          name: "Estado:",
          options: this.$store.state.filterOptions.state
        },
        {
          option: "city",
          name: "Cidade:",
          options: this.$store.state.filterOptions.city
        },
        {
          option: "company",
          name: "Hospital:",
          options: this.$store.state.filterOptions.company
        }
      ],
      datePickers: [
        {
          option: "startDate",
          label: "De"
        },
        {
          option: "endDate",
          label: "Até"
        }
      ],
      filterValues: {
        country: null,
        state: null,
        city: null,
        company: null,
        startDate: null,
        endDate: null
      }
    };
  },
  methods: {
    resetFilters() {
      this.$store.dispatch("resetFilters", {
        filter: this.filter
      });
      this.filterValues = {
        country: null,
        state: null,
        city: null,
        company: null,
        startDate: null,
        endDate: null
      };
    }
  },
  watch: {
    filterValues: {
      handler(value) {
        this.$store.dispatch("setFilters", {
          filter: this.filter,
          filterOptions: value
        });
      },
      deep: true
    }
  },
  props: {
    filter: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.fiterCard {
  background: #ffffff;
  border-radius: 5px;
}

.filterCaption {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #424242;
}

.cancelButton {
  height: 38px;
  width: 163px;
  border-radius: 5px;
}

.buttonText {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  text-transform: uppercase;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #22255c;
}
</style>
